import { expected } from '@aloft/toolkit-shared';

import _ from 'lodash';
import { createContext, useContext } from 'react';

import { Flex } from '../../../summary/components/Flex.js';
import { Table } from '../../../summary/components/Table.js';
import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { marketTrendsTableRows } from './consts.js';
import { MarketTrendsHelpers, MarketTrendsTableRowDef } from './types.js';

type TableProps = {
  chunkSize: number;
  marketTrendsHelpers: MarketTrendsHelpers;
};

const TableContext = createContext<TableProps | null>(null);

export function MarketTrendsTable(props: TableProps) {
  const {
    chunkSize,
    marketTrendsHelpers: { table },
  } = props;

  return (
    <TableContext.Provider value={props}>
      {_.range(0, table.length, chunkSize).map((i) => (
        <TableChunk key={i} offset={i} />
      ))}
    </TableContext.Provider>
  );
}

function TableChunk(props: { offset: number }) {
  const { offset } = props;

  return (
    <Flex marginBottom="0.5rem">
      <Table>
        {marketTrendsTableRows.map((row, i) => (
          <TableRow key={i} offset={offset} row={row} />
        ))}
      </Table>
    </Flex>
  );
}

function TableRow(props: { offset: number; row: MarketTrendsTableRowDef }) {
  const {
    chunkSize,
    marketTrendsHelpers: { table },
  } = expected(useContext(TableContext));
  const {
    offset,
    row: { isHeader, label, cellContent },
  } = props;
  const chunk = table.slice(offset, offset + chunkSize);

  const labelColumnWidth = Number.isFinite(chunkSize) ? '22%' : undefined;
  const dataColumnWidth = Number.isFinite(chunkSize) ? `${78 / chunkSize}%` : undefined;

  return (
    <Tr>
      <Td width={labelColumnWidth}>
        <Typography variant="h5">{label}</Typography>
      </Td>
      {chunk.map((col) => (
        <Td key={col.period} width={dataColumnWidth}>
          <Typography variant={isHeader ? 'h5' : 'body2'}>{cellContent(col)}</Typography>
        </Td>
      ))}
    </Tr>
  );
}
